/**
 * MamaTega Basket — desktop-only bottom-left cart strip.
 * On product pages: optional switch Basket ↔ MamaTega's suggestions (saved AI sets).
 * Set SUGGESTIONS_ENABLED = true to bring the PDP suggestions tab back.
 */
(function () {
  'use strict';
  if (window.__MAMATEGA_BASKET__) return;
  window.__MAMATEGA_BASKET__ = true;

  var ROOT_ID = 'MamaTegaBasket';
  /* Default HIDDEN. Cookie set only when shopper taps Show; Hide clears it. */
  var SHOW_COOKIE = 'mamatega_basket_shown_v3';
  var HIDE_COOKIE = 'mamatega_basket_hidden_v2'; /* legacy — cleared on boot */
  var HIDE_COOKIE_DAYS = 365;
  var LEGACY_HIDE_KEY = 'mamatega_basket_hidden_v1'; /* old localStorage; was also used for auto-minimize */
  var MODE_KEY = 'mtg_bsk_mode_v1';
  var MQ = '(min-width: 1200px)';
  var MAX_VISIBLE = 6;
  var SLOT = 52; /* compact thumbs — keep strip short */
  var GAP = 8; /* space between product cards */
  var PAD = 4;
  var GLOW_MS = 10000;
  /* Off for now — basket (cart) still shows on PDP and everywhere else. Flip to true to re-enable. */
  var SUGGESTIONS_ENABLED = false;
  var SUGGEST_LABEL = "MamaTega's suggestions";
  var FALLBACK_GLOW = {
    yellow: { a: '250,204,21', b: '234,179,8', c: '254,240,138' },
    amber: { a: '251,191,36', b: '245,158,11', c: '253,224,71' },
    night: { a: '37,99,235', b: '29,78,216', c: '96,165,250' },
    red: { a: '239,68,68', b: '185,28,28', c: '248,113,113' },
    green: { a: '16,185,129', b: '4,120,87', c: '52,211,153' },
    'glow-burning-fire': { a: '255,106,0', b: '255,45,0', c: '255,170,0' },
    'glow-violet-purple': { a: '168,85,247', b: '124,58,237', c: '192,132,252' },
    'glow-aurora': { a: '168,85,247', b: '6,182,212', c: '192,132,252' },
    'glow-neon': { a: '16,185,129', b: '139,92,246', c: '52,211,153' },
    'glassmorphous-black': { a: '255,255,255', b: '200,200,210', c: '140,140,155' }
  };

  var prevQtyByKey = null;
  var glowKey = null;
  var glowUntil = 0;
  var glowTimer = null;
  var lastCart = null;
  var fetching = false;
  var mode = 'cart'; /* cart | suggestions */
  var suggestState = null; /* last /api/pdp-suggestions payload */
  var suggestFetching = false;
  var suggestPollTimer = null;

  function $(sel, el) { return (el || document).querySelector(sel); }

  function apiBase() {
    var b = (window.MAMATEGA_API_BASE || window.__MAMATEGA_PDP_API_BASE__ || '').replace(/\/$/, '');
    return b || '';
  }

  function isProductPage() {
    try {
      if (document.body && /\btemplate-product\b/.test(document.body.className || '')) return true;
    } catch (e) {}
    return /^\/products\//i.test(location.pathname || '');
  }

  function productHandle() {
    try {
      if (window.meta && window.meta.product && window.meta.product.handle) {
        return String(window.meta.product.handle).trim();
      }
    } catch (e) {}
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function suggestionsOn() {
    return !!SUGGESTIONS_ENABLED && isProductPage();
  }

  function loadMode() {
    if (!suggestionsOn()) return 'cart';
    try {
      var v = sessionStorage.getItem(MODE_KEY);
      if (v === 'suggestions' || v === 'cart') return v;
    } catch (e) {}
    return 'suggestions'; /* PDP default: MamaTega's suggestions */
  }

  function saveMode(m) {
    if (!suggestionsOn()) {
      mode = 'cart';
      return;
    }
    mode = m === 'suggestions' ? 'suggestions' : 'cart';
    try { sessionStorage.setItem(MODE_KEY, mode); } catch (e) {}
  }

  /* Basket panel is white/black only — do not tint from Theme Experience. */
  function syncThemeGlow(root) {
    if (!root) return;
    try {
      root.style.removeProperty('--mtg-bsk-glow-a');
      root.style.removeProperty('--mtg-bsk-glow-b');
      root.style.removeProperty('--mtg-bsk-glow-c');
    } catch (e) {}
  }

  function itemKey(it) {
    if (!it) return '';
    return String(it.key || it.id || '');
  }

  function qtyMap(items) {
    var map = Object.create(null);
    for (var i = 0; i < (items || []).length; i++) {
      var it = items[i];
      var k = itemKey(it);
      if (!k) continue;
      map[k] = it.quantity || 1;
    }
    return map;
  }

  function findNewestKey(items, prev) {
    if (!items || !items.length) return null;
    if (!prev) {
      /* First paint: Shopify lists oldest→newest — last line is the most recent add */
      return itemKey(items[items.length - 1]) || null;
    }
    var i;
    var added = [];
    var bumped = [];
    for (i = 0; i < items.length; i++) {
      var k = itemKey(items[i]);
      if (!k) continue;
      var q = items[i].quantity || 1;
      if (prev[k] == null) added.push(k);
      else if (q > prev[k]) bumped.push(k);
    }
    if (added.length) return added[added.length - 1];
    if (bumped.length) return bumped[bumped.length - 1];
    return null;
  }

  /** Shopify cart.js is oldest→newest; show newest first (left / start of strip). */
  function orderBasketItems(items, newestKey) {
    var list = (items || []).slice().reverse();
    if (!newestKey || list.length < 2) return list;
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (itemKey(list[i]) === newestKey) {
        idx = i;
        break;
      }
    }
    if (idx > 0) {
      var row = list.splice(idx, 1)[0];
      list.unshift(row);
    }
    return list;
  }

  function pingTitle(root) {
    var title = root && root.querySelector('.mtg-bsk__title');
    if (!title) return;
    title.classList.remove('is-ping');
    void title.offsetWidth;
    title.classList.add('is-ping');
    window.setTimeout(function () {
      title.classList.remove('is-ping');
    }, 1300);
  }

  function scheduleGlowClear(root) {
    if (glowTimer) {
      clearTimeout(glowTimer);
      glowTimer = null;
    }
    var left = Math.max(0, glowUntil - Date.now());
    if (!left) {
      glowKey = null;
      return;
    }
    glowTimer = window.setTimeout(function () {
      glowKey = null;
      glowUntil = 0;
      glowTimer = null;
      var el = root && root.querySelector('.mtg-bsk__item.is-new-glow');
      if (el) el.classList.remove('is-new-glow');
    }, left);
  }

  function desktopOk() {
    try { return window.matchMedia(MQ).matches; } catch (e) { return false; }
  }

  function cartDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      if (
        drawer.classList.contains('drawer--is-open') ||
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('is-active') ||
        drawer.getAttribute('aria-hidden') === 'false'
      ) return true;
    }
    var b = document.body;
    return !!(
      b.classList.contains('js-drawer-open-cart') ||
      (b.classList.contains('js-drawer-open-right') && b.classList.contains('js-drawer-open'))
    );
  }

  function openCartDrawer() {
    try {
      var btn = document.querySelector('.js-drawer-open-cart, [data-mgh-action="cart"], a[aria-controls="CartDrawer"]');
      if (btn) {
        btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        return;
      }
    } catch (e) {}
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    drawer.classList.add('is-open', 'is-active', 'drawer--is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add(
      'js-drawer-open', 'drawer-open', 'overflow-hidden', 'mgh-layer-open',
      'js-drawer-open-right', 'js-drawer-open-cart'
    );
    document.body.classList.remove('js-drawer-open-left', 'js-drawer-open-nav');
    try {
      window.dispatchEvent(new CustomEvent('mamatega:cart-drawer', { detail: { open: true } }));
    } catch (err) {}
  }

  function imgUrl(item) {
    var src = (item && (item.image || item.featured_image)) || '';
    if (!src && item && item.featured_image && item.featured_image.url) src = item.featured_image.url;
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    /* Landscape crop for basket thumbs */
    return src.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_220x146$1$2');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function widthForCount(n) {
    var visible = Math.max(1, Math.min(MAX_VISIBLE, n || 1));
    return PAD * 2 + visible * SLOT + Math.max(0, visible - 1) * GAP;
  }

  function readCookie(name) {
    try {
      var parts = String(document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].replace(/^\s+/, '');
        if (p.indexOf(name + '=') === 0) {
          return decodeURIComponent(p.slice(name.length + 1));
        }
      }
    } catch (e) {}
    return '';
  }

  function writeCookie(name, value, days) {
    try {
      var maxAge = Math.max(0, Math.floor((days || 0) * 86400));
      document.cookie =
        name + '=' + encodeURIComponent(value) +
        '; Path=/' +
        '; Max-Age=' + maxAge +
        '; SameSite=Lax';
    } catch (e) {}
  }

  function clearCookie(name) {
    try {
      document.cookie = name + '=; Path=/; Max-Age=0; SameSite=Lax';
    } catch (e) {}
  }

  function isUserHidden() {
    /* Hidden unless the shopper explicitly tapped Show. */
    return readCookie(SHOW_COOKIE) !== '1';
  }

  function setUserHidden(on) {
    if (on) clearCookie(SHOW_COOKIE);
    else writeCookie(SHOW_COOKIE, '1', HIDE_COOKIE_DAYS);
    /* Drop legacy hide / auto-minimize flags */
    clearCookie(HIDE_COOKIE);
    try { localStorage.removeItem(LEGACY_HIDE_KEY); } catch (e) {}
  }

  var BASKET_SVG =
    '<svg class="mtg-bsk-fab__icon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M7.2 7.5h9.6l-.7 9.1a1.8 1.8 0 0 1-1.8 1.7H9.7a1.8 1.8 0 0 1-1.8-1.7L7.2 7.5Z" opacity=".92"/>' +
      '<path fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" d="M4.5 7.5h15M8.2 7.5l1.1-3h5.4l1.1 3"/>' +
      '<circle cx="9.2" cy="20" r="1.15" fill="currentColor"/>' +
      '<circle cx="14.8" cy="20" r="1.15" fill="currentColor"/>' +
    '</svg>';

  function ensureDock() {
    var dock = document.getElementById('MamaTegaBasketDock');
    if (dock) return dock;
    dock = document.createElement('div');
    dock.id = 'MamaTegaBasketDock';
    dock.className = 'mtg-bsk-dock';
    document.body.appendChild(dock);
    return dock;
  }

  function ensureShowChip() {
    var chip = document.getElementById('MamaTegaBasketShow');
    if (chip) return chip;
    var dock = ensureDock();
    chip = document.createElement('button');
    chip.id = 'MamaTegaBasketShow';
    chip.type = 'button';
    chip.className = 'mtg-bsk-show mtg-bsk-fab';
    chip.setAttribute('aria-label', 'Show basket');
    chip.innerHTML = BASKET_SVG + '<span class="mtg-bsk-fab__count" data-mtg-bsk-fab-count hidden></span>';
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      setUserHidden(false);
      syncVisibility();
    });
    dock.appendChild(chip);
    return chip;
  }

  function headHtml() {
    var switchHtml = suggestionsOn()
      ? (
        '<div class="mtg-bsk__mode" data-mtg-bsk-mode role="tablist" aria-label="Basket or suggestions">' +
          '<button type="button" class="mtg-bsk__mode-btn" data-mtg-bsk-mode-cart role="tab">Basket</button>' +
          '<button type="button" class="mtg-bsk__mode-btn" data-mtg-bsk-mode-sug role="tab">' +
            escapeHtml(SUGGEST_LABEL) +
          '</button>' +
        '</div>'
      )
      : '<p class="mtg-bsk__title">Basket</p>';
    return (
      '<div class="mtg-bsk__head">' +
        switchHtml +
        '<div class="mtg-bsk__head-right">' +
          '<p class="mtg-bsk__count" data-mtg-bsk-count></p>' +
          '<button type="button" class="mtg-bsk__view" data-mtg-bsk-view aria-label="View cart">View</button>' +
          '<button type="button" class="mtg-bsk__hide" data-mtg-bsk-hide aria-label="Hide basket">Hide</button>' +
        '</div>' +
      '</div>'
    );
  }

  function ensureRoot() {
    var root = document.getElementById(ROOT_ID);
    if (root) return root;
    var dock = ensureDock();
    root = document.createElement('aside');
    root.id = ROOT_ID;
    root.setAttribute('aria-label', 'Basket — items in your cart');
    root.innerHTML =
      headHtml() +
      '<p class="mtg-bsk__hint" data-mtg-bsk-hint>Swipe for more</p>' +
      '<div class="mtg-bsk__track-wrap">' +
        '<div class="mtg-bsk__track" data-mtg-bsk-track role="list"></div>' +
      '</div>';
    dock.appendChild(root);
    root.addEventListener('click', onRootClick);
    ensureShowChip();
    return root;
  }

  function syncModeButtons(root) {
    if (!root || !suggestionsOn()) return;
    var cartBtn = root.querySelector('[data-mtg-bsk-mode-cart]');
    var sugBtn = root.querySelector('[data-mtg-bsk-mode-sug]');
    if (cartBtn) {
      cartBtn.classList.toggle('is-active', mode === 'cart');
      cartBtn.setAttribute('aria-selected', mode === 'cart' ? 'true' : 'false');
    }
    if (sugBtn) {
      sugBtn.classList.toggle('is-active', mode === 'suggestions');
      sugBtn.setAttribute('aria-selected', mode === 'suggestions' ? 'true' : 'false');
    }
    root.classList.toggle('mtg-bsk--suggestions', mode === 'suggestions');
    var view = root.querySelector('[data-mtg-bsk-view]');
    if (view) {
      if (mode === 'suggestions') {
        view.hidden = true;
      } else {
        view.hidden = false;
      }
    }
  }

  function changeQty(key, qty) {
    if (!key) return;
    fetching = true;
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty | 0) })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) {
          lastCart = cart;
          paint();
        } else {
          refresh();
        }
      })
      .catch(function () { refresh(); })
      .then(function () {
        fetching = false;
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: lastCart }));
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: lastCart }));
        } catch (e) {}
      });
  }

  function onRootClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-mtg-bsk-mode-cart]')) {
      e.preventDefault();
      e.stopPropagation();
      saveMode('cart');
      paint();
      return;
    }
    if (t.closest('[data-mtg-bsk-mode-sug]')) {
      e.preventDefault();
      e.stopPropagation();
      saveMode('suggestions');
      paint();
      loadSuggestions(false);
      return;
    }

    if (t.closest('[data-mtg-bsk-view]')) {
      e.preventDefault();
      e.stopPropagation();
      openCartDrawer();
      return;
    }

    if (t.closest('[data-mtg-bsk-hide]')) {
      e.preventDefault();
      e.stopPropagation();
      setUserHidden(true);
      syncVisibility();
      return;
    }

    var minus = t.closest('[data-mtg-bsk-minus]');
    var plus = t.closest('[data-mtg-bsk-plus]');
    if (minus || plus) {
      e.preventDefault();
      e.stopPropagation();
      var btn = minus || plus;
      var key = btn.getAttribute('data-key');
      var cur = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
      if (minus) changeQty(key, cur - 1);
      else changeQty(key, cur + 1);
      return;
    }

    var link = t.closest('a.mtg-bsk__thumb-link');
    if (link && movedDrag) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  var movedDrag = false;

  function bindDrag(track) {
    if (!track || track.getAttribute('data-mtg-bsk-drag') === '1') return;
    track.setAttribute('data-mtg-bsk-drag', '1');
    var down = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest && e.target.closest('button')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true;
      movedDrag = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) movedDrag = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag(e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (movedDrag) {
        e.preventDefault();
        e.stopPropagation();
        movedDrag = false;
      }
    }, true);
  }

  function renderCart(cart) {
    var root = ensureRoot();
    syncThemeGlow(root);
    syncModeButtons(root);
    var track = $('[data-mtg-bsk-track]', root);
    var countEl = $('[data-mtg-bsk-count]', root);
    var hint = $('[data-mtg-bsk-hint]', root);
    if (!track) return;

    var rawItems = (cart && cart.items) || [];
    var hadPrev = !!prevQtyByKey;
    var newest = findNewestKey(rawItems, prevQtyByKey);
    if (newest) {
      glowKey = newest;
      glowUntil = Date.now() + GLOW_MS;
      if (hadPrev) pingTitle(root);
    } else if (glowKey && Date.now() > glowUntil) {
      glowKey = null;
    }
    prevQtyByKey = qtyMap(rawItems);

    /* Newest-first strip; pin a just-added / qty-bumped line to the left */
    var items = orderBasketItems(rawItems, newest);
    var n = items.length;
    var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : items.reduce(function (a, it) {
      return a + (it.quantity || 1);
    }, 0);

    root.style.setProperty('--mtg-bsk-slot', SLOT + 'px');
    root.style.setProperty('--mtg-bsk-gap', GAP + 'px');
    root.style.setProperty('--mtg-bsk-pad', PAD + 'px');
    root.style.setProperty('--mtg-bsk-w', widthForCount(Math.max(n, 1)) + 'px');
    root.classList.toggle('mtg-bsk--scrollable', n > MAX_VISIBLE);
    root.setAttribute('aria-label', 'Basket — items in your cart');

    if (countEl) {
      countEl.textContent = itemCount === 1 ? '1 item' : itemCount + ' items';
    }
    if (hint) hint.textContent = 'Swipe for more';

    if (!n) {
      track.innerHTML = '';
      glowKey = null;
      syncVisibility();
      return;
    }

    var activeGlow = glowKey && Date.now() < glowUntil ? glowKey : null;
    var html = '';
    for (var i = 0; i < n; i++) {
      var it = items[i] || {};
      var title = it.product_title || it.title || 'Item';
      var brand = String(it.vendor || it.product_vendor || '').trim() || title;
      var href = it.url || (it.handle ? '/products/' + it.handle : '/cart');
      var src = imgUrl(it);
      var qty = it.quantity || 1;
      var key = itemKey(it);
      var glowCls = activeGlow && key === activeGlow ? ' is-new-glow' : '';
      html +=
        '<div class="mtg-bsk__item' + glowCls + '" role="listitem" data-key="' + escapeHtml(key) + '">' +
          '<a class="mtg-bsk__thumb-link" href="' + escapeHtml(href) + '" title="' + escapeHtml(title) + (qty > 1 ? ' ×' + qty : '') + '">' +
            '<span class="mtg-bsk__thumb">' +
              (src
                ? '<img src="' + escapeHtml(src) + '" alt="" width="88" height="88" loading="lazy" decoding="async">'
                : '') +
            '</span>' +
          '</a>' +
          '<p class="mtg-bsk__name">' + escapeHtml(brand) + '</p>' +
          '<div class="mtg-bsk__qty-row" aria-label="Quantity">' +
            '<button type="button" class="mtg-bsk__qty-btn" data-mtg-bsk-minus data-key="' + escapeHtml(key) + '" data-qty="' + qty + '" aria-label="Decrease quantity">−</button>' +
            '<span class="mtg-bsk__qty-num">' + qty + '</span>' +
            '<button type="button" class="mtg-bsk__qty-btn" data-mtg-bsk-plus data-key="' + escapeHtml(key) + '" data-qty="' + qty + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>';
    }
    track.innerHTML = html;
    bindDrag(track);
    /* Always start the strip on the newest item (left edge) */
    track.scrollLeft = 0;
    if (activeGlow) scheduleGlowClear(root);
    syncVisibility();
  }

  function renderSuggestions() {
    var root = ensureRoot();
    syncThemeGlow(root);
    syncModeButtons(root);
    var track = $('[data-mtg-bsk-track]', root);
    var countEl = $('[data-mtg-bsk-count]', root);
    var hint = $('[data-mtg-bsk-hint]', root);
    if (!track) return;

    var products = (suggestState && suggestState.products) || [];
    var n = products.length;
    var setsCount = suggestState && suggestState.setsCount ? suggestState.setsCount : 0;
    var generating = !!(suggestState && suggestState.generating);

    root.style.setProperty('--mtg-bsk-slot', SLOT + 'px');
    root.style.setProperty('--mtg-bsk-gap', GAP + 'px');
    root.style.setProperty('--mtg-bsk-pad', PAD + 'px');
    root.style.setProperty('--mtg-bsk-w', widthForCount(Math.max(n || 1, 1)) + 'px');
    root.classList.toggle('mtg-bsk--scrollable', n > MAX_VISIBLE);
    root.setAttribute('aria-label', SUGGEST_LABEL);

    if (countEl) {
      if (generating && !n) countEl.textContent = 'Picking…';
      else if (n) countEl.textContent = n === 1 ? '1 pick' : n + ' picks';
      else countEl.textContent = setsCount ? '—' : 'Soon';
    }
    if (hint) {
      hint.textContent = setsCount > 1
        ? 'Swipe for more · ' + setsCount + ' of 5 saved'
        : 'Swipe for more';
    }

    if (!n) {
      track.innerHTML =
        '<div class="mtg-bsk__item mtg-bsk__item--empty" role="listitem">' +
          '<p class="mtg-bsk__name">' +
            (generating ? 'Finding picks…' : 'Suggestions coming soon') +
          '</p>' +
        '</div>';
      syncVisibility();
      return;
    }

    var html = '';
    for (var i = 0; i < n; i++) {
      var it = products[i] || {};
      var title = it.title || 'Product';
      var brand = String(it.vendor || '').trim() || title;
      var href = it.url || (it.handle ? '/products/' + it.handle : '#');
      var src = imgUrl(it);
      html +=
        '<div class="mtg-bsk__item mtg-bsk__item--suggest" role="listitem">' +
          '<a class="mtg-bsk__thumb-link" href="' + escapeHtml(href) + '" title="' + escapeHtml(title) + '">' +
            '<span class="mtg-bsk__thumb">' +
              (src
                ? '<img src="' + escapeHtml(src) + '" alt="" width="96" height="96" loading="lazy" decoding="async">'
                : '') +
            '</span>' +
          '</a>' +
          '<p class="mtg-bsk__name">' + escapeHtml(brand) + '</p>' +
          (it.price
            ? '<p class="mtg-bsk__price">' + escapeHtml(it.price) + '</p>'
            : '') +
        '</div>';
    }
    track.innerHTML = html;
    bindDrag(track);
    syncVisibility();
  }

  function paint() {
    if (mode === 'suggestions' && suggestionsOn()) renderSuggestions();
    else renderCart(lastCart);
  }

  function setVisible(on) {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    root.classList.toggle('mtg-bsk--visible', !!on);
  }

  function hasCartItems() {
    return !!(lastCart && lastCart.items && lastCart.items.length);
  }

  function hasSuggestContent() {
    return !!(
      (suggestState && suggestState.products && suggestState.products.length) ||
      (suggestState && suggestState.generating)
    );
  }

  function syncVisibility() {
    var root = ensureRoot();
    var chip = ensureShowChip();
    root.classList.add('mtg-bsk--ready');
    syncModeButtons(root);
    var drawerOpen = cartDrawerOpen();
    var userHidden = isUserHidden();
    root.classList.toggle('mtg-bsk--hidden-drawer', drawerOpen);
    root.classList.toggle('mtg-bsk--user-hidden', userHidden);

    var contentOk = mode === 'suggestions' && suggestionsOn()
      ? (hasSuggestContent() || true) /* show strip on PDP even while loading */
      : hasCartItems();

    /* On PDP suggestions mode always try to show (desktop); cart mode needs items */
    if (mode === 'suggestions' && suggestionsOn()) contentOk = true;

    var canShow = desktopOk() && contentOk && !drawerOpen && !userHidden;
    if (mode === 'cart' && !hasCartItems()) canShow = false;

    /* Full basket only after Show; otherwise the FAB chip is enough. */
    var wantDock = desktopOk() && !drawerOpen && contentOk && (
      (mode === 'cart' && hasCartItems()) ||
      (mode === 'suggestions' && suggestionsOn())
    );
    if (mode === 'cart' && !hasCartItems()) wantDock = false;
    var dock = ensureDock();
    var expand = wantDock && !userHidden;
    setVisible(expand);
    root.classList.toggle('mtg-bsk--user-hidden', !!userHidden);
    var showChip = wantDock && userHidden;
    chip.classList.toggle('mtg-bsk-show--visible', showChip);
    dock.classList.toggle('mtg-bsk-dock--ready', desktopOk());
    dock.classList.toggle('mtg-bsk-dock--has-content', wantDock);
    dock.classList.toggle('mtg-bsk-dock--expanded', expand);
    var fabCount = chip.querySelector('[data-mtg-bsk-fab-count]');
    if (fabCount) {
      if (mode === 'suggestions') {
        fabCount.hidden = true;
      } else {
        var nFab = lastCart && typeof lastCart.item_count === 'number'
          ? lastCart.item_count
          : ((lastCart && lastCart.items) || []).length;
        if (nFab > 0) {
          fabCount.hidden = false;
          fabCount.textContent = String(nFab > 99 ? '99+' : nFab);
        } else {
          fabCount.hidden = true;
        }
      }
    }
  }

  function refresh() {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) {
          lastCart = cart;
          if (mode === 'cart' || !isProductPage()) paint();
          else syncVisibility();
        } else {
          syncVisibility();
        }
      })
      .catch(function () { syncVisibility(); })
      .then(function () { fetching = false; });
  }

  function clearSuggestPoll() {
    if (suggestPollTimer) {
      clearTimeout(suggestPollTimer);
      suggestPollTimer = null;
    }
  }

  function loadSuggestions(force) {
    if (!suggestionsOn()) return;
    var handle = productHandle();
    if (!handle) return;
    var base = apiBase();
    if (!base) return;
    if (suggestFetching && !force) return;
    suggestFetching = true;
    var url = base + '/api/pdp-suggestions?handle=' + encodeURIComponent(handle);
    fetch(url, { credentials: 'omit', mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.ok !== false) {
          suggestState = data;
          if (data.label) SUGGEST_LABEL = data.label; /* keep module label in sync if server sends */
        }
        if (mode === 'suggestions') paint();
        else syncVisibility();
        clearSuggestPoll();
        if (data && data.generating && !(data.products && data.products.length)) {
          suggestPollTimer = window.setTimeout(function () {
            loadSuggestions(true);
          }, 2500);
        } else if (data && data.canGenerateMore && mode === 'suggestions') {
          /* soft re-fetch later so a newly filled set can rotate in */
          suggestPollTimer = window.setTimeout(function () {
            loadSuggestions(true);
          }, 12000);
        }
      })
      .catch(function () {
        if (mode === 'suggestions') paint();
      })
      .then(function () { suggestFetching = false; });
  }

  function boot() {
    mode = loadMode();
    /* Clear legacy flags so default stays hidden until Show. */
    try { localStorage.removeItem(LEGACY_HIDE_KEY); } catch (e) {}
    clearCookie(HIDE_COOKIE);
    var root = ensureRoot();
    syncThemeGlow(root);
    paint();
    refresh();
    if (suggestionsOn()) loadSuggestions(false);
    syncVisibility();

    window.addEventListener('mamatega:theme-experience', function () {
      syncThemeGlow(ensureRoot());
    });
    window.addEventListener('storage', function (ev) {
      if (ev.key === 'mamatega_chat_dark_variant_v2' || ev.key === 'mamatega_theme_experience_accents_v1') {
        syncThemeGlow(ensureRoot());
      }
    });

    window.addEventListener('mamatega:cart-drawer', function (ev) {
      var open = !!(ev && ev.detail && ev.detail.open);
      var root = ensureRoot();
      root.classList.toggle('mtg-bsk--hidden-drawer', open);
      syncVisibility();
      if (!open) refresh();
    });

    ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (name) {
      document.addEventListener(name, refresh);
      window.addEventListener(name, refresh);
      document.documentElement.addEventListener(name, refresh);
    });

    try {
      if (window.jQuery) {
        window.jQuery(document).on('cart.requestComplete updateCart.ajaxCart', refresh);
      }
    } catch (e) {}

    if (!window.__mtgBskFetchPatched && typeof window.fetch === 'function') {
      window.__mtgBskFetchPatched = true;
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = nativeFetch(input, init);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { window.setTimeout(refresh, 80); }).catch(function () {});
        }
        return p;
      };
    }

    var mq = window.matchMedia(MQ);
    function onMq() { syncVisibility(); }
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    window.addEventListener('resize', syncVisibility, { passive: true });

    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(syncVisibility).observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    }
    if (window.MutationObserver) {
      new MutationObserver(syncVisibility).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    window.setInterval(function () {
      if (desktopOk() && !cartDrawerOpen()) refresh();
    }, 45000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
